import { render, staticRenderFns } from "./humanInjuryList.vue?vue&type=template&id=083b2308&scoped=true"
import script from "./humanInjuryList.vue?vue&type=script&lang=js"
export * from "./humanInjuryList.vue?vue&type=script&lang=js"
import style0 from "./humanInjuryList.vue?vue&type=style&index=0&id=083b2308&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083b2308",
  null
  
)

export default component.exports